/*eslint-disable require-yield*/
import jquery from 'jquery'; //eslint-disable-line no-unused-vars
import {
  put,
  fork,
  take,
  call,
  race,
  cancel
} from 'redux-saga/effects';
import { delay, takeLatest } from 'redux-saga';
// import queryString from 'query-string';
import _ from 'lodash';
import {
  ACTIONS_RECEIVED
} from './target';
import {
  showGlobalSpinner,
  hideGlobalSpinner
} from '../common/common';
import {
  PAGE_LOADED
} from '../dataLayer/dataLayer';
import contentProvider from '../contentProvider/contentProvider';

// WATCHERS
export function* actionsReceivedWatch() {
  yield* takeLatest(ACTIONS_RECEIVED, actionsReceivedWorker);
}

// WORKERS
export function* targetFlow() {

  // TODO:Remove. for testing/debugging only
  const simulateTargetCall = (success, delay, instructions) => {
    const defaultnstructions = {
      "ReactJSActions": {
        "config": {
          "showPageTopMessage": true
        },
        "content": {
          "offersFilter.offerCardBannerGreeting": "new T&T greeting",
          "review.pageHeader": "new T&T pageHeader"
        }
      }
    };
    const successEvent = new CustomEvent('target-data-success', {detail: instructions || defaultnstructions});
    const doneEvent = new Event('target-data-done');
    const failEvent = new Event('target-data-fail');

    $(document).on('c-tracking-log-page', () => {
      setTimeout(() => document.dispatchEvent(successEvent), 100);
      setTimeout(() => document.dispatchEvent(success ? doneEvent : failEvent), delay);
    });
  };

  // to allow tests from console
  window.simulateTargetCall = simulateTargetCall;

  // Simulate successful call
  // simulateTargetCall(true, 500);
  // Simulate failed call
  // simulateTargetCall(false, 500);
  // // Simulate timeout
  // simulateTargetCall(true, 5000);

  // switch to enable/disable T&T
  // const query = queryString.parse(window.location.search);
  //
  // if (query.target !== 'true') {
  //   return;
  // }

  const doneEventHandler = () => new Promise(resolve => document.addEventListener('target-data-done', resolve));
  const successEventHandler = () => new Promise(resolve => document.addEventListener('target-data-success', resolve));
  const failEventHandler = () => new Promise(resolve => document.addEventListener('target-data-fail', resolve));
  const timeoutDelay = 500;
  const actionsList =[];

  function* successSaga() {

    while (true) {
      const success = yield call(successEventHandler);

      _.get(success, 'detail.ReactJSActions') && actionsList.push(success.detail.ReactJSActions);
    }
  }

  try {
    while (true) {
      yield take(PAGE_LOADED);
      yield put(showGlobalSpinner());
      const successTask = yield fork(successSaga);

      const {done} = yield race({
        done: call(doneEventHandler),
        fail: call(failEventHandler),
        timeout: call(delay, timeoutDelay)
      });

      yield cancel(successTask);

      if (done) {
        yield actionsList.map(actions => put({
          type: ACTIONS_RECEIVED,
          payload: actions
        }));
      }
      yield put(hideGlobalSpinner());
    }
  } catch(e) {
    //
  }

}

export function* actionsReceivedWorker({payload: actions}) {
  actions.content && contentProvider.updateContent(actions.content);
}

export default function* interactionSagas() {
  yield [
    fork(targetFlow),
    fork(actionsReceivedWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/target/targetSagas.js
 **/